module.exports = __webpack_public_path__ + "img/mubiaoguanli.765d6bf3.png";